import QuickEditSpecContainer from "./QuickEditSpecContainer";
export default QuickEditSpecContainer;
